export default __webpack_public_path__ + "static/media/genhaven-color.cd75aed8.png";